import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import Raven from 'raven-js';
import { OasPropType, OperationPropType } from '../../../lib/api-explorer/models/Oas';

// @ts-expect-error Untyped
import { getResponse, getResponseStatus } from '../../TryIt/selectors';
import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
// @ts-expect-error Untyped
import LoadingHOC from '../../../lib/hoc/LoadingHOC';
// @ts-expect-error Untyped
import { RequestStatusPropType } from '../../../lib/models/RequestStatus';
// @ts-expect-error Untyped
import CodeMirror from '../../CodeSample/components/CodeMirror';
// @ts-expect-error Untyped
import ExampleResponse from './ExampleResponse';
import { ResponseSchema } from './ResponseSchema';

// @ts-expect-error Untyped
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = styled(UITabs).withConfig({
  displayName: "Response__Tabs",
  componentId: "zxk5qt-0"
})(["font-size:14px;"]);
const Response = ({
  exampleResponses,
  newLayout,
  oas,
  operation,
  response,
  responseStatus
}) => {
  const [state, setState] = useState({
    activeTab: null
  });
  const setTab = useCallback(({
    target: {
      value
    }
  }) => {
    setState({
      activeTab: value
    });
  }, []);
  const renderResponse = useCallback(() => {
    let value;
    let mode;
    if (response) {
      value = response.responseBody;
      if (typeof response.responseBody !== 'string') {
        value = JSON.stringify(response.responseBody, null, 2);
      }
      if (!response.status && response.status !== 0) {
        // Try to determine why we sometimes get sentries like
        // https://sentry.hubteam.com/sentry/endpoint-reference-ui/issues/19794539/
        // TODO: Eventually remove / handle better
        Raven.captureMessage('Missing response.status in Response', {
          extra: {
            response
          }
        });
      }
      value = `${I18n.text('developer-docs-shared-components.response.response.httpCode', {
        code: response.status || response.status === 0 ? response.status : 'Unknown'
      })}\n\n${value}`;
      mode = response.type;
    }
    return /*#__PURE__*/_jsx(LoadingHOC, {
      statuses: [responseStatus],
      error: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.response.error.title"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.response.error.body"
        })
      },
      children: response && /*#__PURE__*/_jsx(CodeMirror, {
        height: "300px",
        value: value,
        mode: mode
      })
    });
  }, [response, responseStatus]);
  return /*#__PURE__*/_jsxs("div", {
    className: "response-panel",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "response-header",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.response.headers.response"
      })
    }), /*#__PURE__*/_jsxs(Tabs, {
      selected: state.activeTab || (responseStatus.uninitialized ? 'example' : 'response'),
      onSelectedChange: setTab,
      panelClassName: "p-x-0 p-bottom-2",
      children: [!responseStatus.uninitialized && /*#__PURE__*/_jsx(UITab, {
        tabId: "response",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.headers.response"
        }),
        children: renderResponse()
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: "example",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.headers.exampleResponse"
        }),
        children: /*#__PURE__*/_jsx(ExampleResponse, {
          exampleResponses: exampleResponses,
          oas: oas,
          operation: operation,
          response: response,
          newLayout: newLayout
        })
      }), /*#__PURE__*/_jsx(UITab, {
        tabId: "schema",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.headers.schema"
        }),
        children: /*#__PURE__*/_jsx(ResponseSchema, {
          operation: operation,
          oas: oas,
          collapsible: newLayout
        })
      })]
    })]
  });
};
Response.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  docId: PropTypes.string.isRequired,
  // Used by selector
  exampleResponses: PropTypes.arrayOf(PropTypes.shape({})),
  newLayout: PropTypes.bool,
  oas: OasPropType.isRequired,
  operation: OperationPropType.isRequired,
  response: PropTypes.object,
  responseStatus: RequestStatusPropType.isRequired
};
Response.defaultProps = {
  exampleResponses: []
};
const mapStateToProps = (state, ownProps) => {
  return {
    response: getResponse(state, ownProps),
    responseStatus: getResponseStatus(state, ownProps)
  };
};
export default connect(mapStateToProps)(Response);